import { HttpClient, RequestConfig } from "@planzone/services";

function createApiUrlProvider(httpClient: HttpClient): HttpClient {
  return {
    sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
      return httpClient.sendHttpRequest({
        baseUrl: "/api",
        ...config,
        headers: {
          ...config.headers,
        },
      });
    },
  };
}

export { createApiUrlProvider };
